export function assertNonNullishProperties<
  T extends Record<string, unknown>,
  K extends readonly (keyof T)[],
>(
  obj: T,
  keys: K,
): asserts obj is T & {
  [P in K[number]]-?: NonNullable<T[P]>;
} {
  for (const key of keys) {
    if (obj[key] == null || obj[key] === undefined) {
      throw new Error(`Property "${String(key)}" is null or undefined`);
    }
  }
}
